var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StudyGuide"},[_c('ul',[_c('li',[_c('img',{attrs:{"src":require("../assets/StudyGuide/01.jpg"),"alt":""}})]),_c('li',[_c('img',{attrs:{"src":require("../assets/StudyGuide/02.jpg"),"alt":""}})])])])
}]

export { render, staticRenderFns }